<script setup lang="ts">
import { EProviders, type MyAccountProviderType } from '@rfc/rfc-components-library/types'
import { computed, provide } from 'vue'

const myAccountProvider = computed<MyAccountProviderType>(() => ({}))

provide<MyAccountProviderType>(EProviders.MY_ACCOUNT, myAccountProvider.value)
</script>

<template>
    <slot />
</template>
